// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"2c521ab2","822":"6b8c2bfe"}[chunkId] + ".chunk.css";
};